"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { useEffect } from "react"
import { useActiveNav } from "@/lib/active-nav-context"
import { cn } from "@/utils/helpers/utils"

export default function NavItemDesktop({
   href,
   label,
   onNavigate,
   onPrefetch,
}: {
   href: string
   label: string
   onNavigate?: (e: React.MouseEvent<HTMLAnchorElement>) => void
   onPrefetch?: () => void
}) {
   const pathname = usePathname()
   const { activeNavHref } = useActiveNav()
   const isActive = pathname.startsWith(href) || activeNavHref === href
   useEffect(() => {
      onPrefetch?.()
      // onPrefetch is stable (module-level cache) — runs once on first mount per session
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return (
      <li className="group relative flex flex-col items-center">
         <Link
            href={href}
            onClick={onNavigate}
            onAuxClick={onNavigate}
            className={cn(
               "px-4 py-1  text-[18px] text-nav-text transition-colors group-hover:text-custom-primary",
               isActive && "text-custom-primary",
            )}
         >
            {label}
         </Link>

         <span
            className={cn(
               "absolute bottom-[-15px] left-1/2 h-[3px] w-[80%] -translate-x-1/2 transition-all ",
               isActive ? "bg-custom-primary" : "bg-transparent group-hover:bg-custom-primary",
            )}
         />
      </li>
   )
}
